/** @type {import('tailwindcss').Config} */
module.exports = {
  content: ['./src/**/*.{js,ts,jsx,tsx,mdx}'],
  theme: {
    extend: {
      scale: {
        101: '1.01',
        102: '1.02',
      },
      transitionProperty: {
        height: 'height',
      },
      fontSize: {
        '3xs': '0.5rem',
        '2xs': '0.625rem',
      },
      flex: {
        1: '1 1 0%',
        2: '2 2 0%',
        3: '3 3 0%',
        4: '4 4 0%',
        5: '5 5 0%',
        6: '6 6 0%',
        7: '7 7 0%',
        8: '8 8 0%',
      },
      keyframes: {
        'pulse-left-to-right': {
          '0%': { transform: 'translateX(0%) scale(1)', opacity: '0.5' },
          '25%': { transform: 'translateX(25%) scale(1.1)', opacity: '0.75' },
          '50%': { transform: 'translateX(50%) scale(1)', opacity: '1' },
          '75%': { transform: 'translateX(75%) scale(1.1)', opacity: '0.75' },
          '100%': { transform: 'translateX(100%) scale(1)', opacity: '0.5' },
        },
      },
      animation: {
        'pulse-slow': 'pulse 5s ease-in-out infinite',
        'pulse-fast': 'pulse 0.5s ease-in-out infinite',
        'pulse-x': 'pulse-left-to-right 2s ease-in-out infinite',
      },
      boxShadow: {
        borderHeader: '0px 1px 0px 0px #EBEDEF',
        productCard: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      },
      colors: {
        primary: '#3B3F44',
        secondary: '#D30B0B',
        warning: '#B45309',
        red: {
          50: '#FFF5F5',
          75: '#FEF0F0',
          100: '#FED7D7',
          500: '#E53E3E',
          600: '#D30B0B',
          700: '#9B2C2C',
          800: '#822727',
        },
        gray: {
          10: '#F3F3F3',
          50: '#F8F9FA',
          75: '#F4F5F6',
          100: '#EBEDEF',
          150: '#E0E3E6',
          200: '#D5D8DB',
          250: '#CED3D8',
          300: '#A9B3BC',
          400: '#BDC4CB',
          500: '#95A1AC',
          650: '#7C7C7D',
          700: '#646D74',
          800: '#55616D',
          900: '#3D3D3D',
          1000: '#1D2125',
        },
        pink: {
          50: '#FAE0E2',
          400: '#C03744',
          800: '#8C1823',
          900: '#3B3F44',
        },
        green: {
          50: '#F0FFF4',
          75: '#ECFDF5',
          100: '#C6F6D5',
          200: '#F0FFF4',
          300: '#CFF1DF',
          400: '#48BB78',
          500: '#38A169',
          600: '#059669',
          800: '#22543D',
          900: '#10B981',
          1000: '#047857',
        },
        yellow: {
          300: '#FDE68A',
        },
        orange: {
          500: '#F59E0B',
        },
      },
    },
    transitionDuration: {
      0: '0ms',
      25: '25ms',
      50: '50ms',
      75: '75ms',
      100: '100ms',
      200: '200ms',
      300: '300ms',
      400: '400ms',
      500: '500ms',
      600: '600ms',
      700: '700ms',
      750: '750ms',
      1000: '1000ms',
      1500: '1500ms',
      2000: '2000ms',
      2500: '2500ms',
      3000: '3000ms',
      3500: '3500ms',
      4000: '4000ms',
      4500: '4500ms',
      5000: '5000ms',
    },
    spacing: {
      0: 0,
      px: 1,
      0.5: '2px',
      0.75: '3px',
      1: '4px',
      1.25: '5px',
      1.5: '6px',
      1.75: '7px',
      2: '8px',
      2.125: '8.5px',
      2.25: '9px',
      2.5: 10,
      3: 12,
      3.25: 13,
      3.5: 14,
      3.75: 15,
      4: 16,
      4.5: 18,
      4.75: 19,
      5: 20,
      5.5: 22,
      6: 24,
      7: 28,
      8: 32,
      9: 36,
      9.5: 38,
      10: 40,
      10.5: 42,
      11: 44,
      12: 48,
      13: 52,
      13.25: 53,
      13.5: 54,
      14: 56,
      15: 60,
      15.25: 61,
      15.5: 62,
      16: 64,
      20: 80,
      22: 88,
      24: 96,
      25: 100,
      26: 104,
      28: 112,
      30: 120,
      32: 128,
      33: 132,
      34: 136,
      35: 140,
      36: 144,
      40: 160,
      41: 164,
      42: 168,
      43: 172,
      44: 176,
      46: 184,
      48: 192,
      49: 196,
      50: 200,
      50.25: 201,
      50.5: 202,
      50.75: 203,
      51: 204,
      51.25: 205,
      51.5: 206,
      52: 208,
      53: 212,
      53.25: 213,
      53.5: 214,
      53.75: 215,
      54: 216,
      54.25: 217,
      54.5: 218,
      54.75: 219,
      55: 220,
      56: 224,
      57: 228,
      57.5: 230,
      57.75: 231,
      58: 232,
      59: 236,
      60: 240,
      61: 244,
      62: 248,
      63: 252,
      64: 256,
      64.5: 258,
      65: 260,
      66: 264,
      68: 272,
      69: 276,
      70: 280,
      72: 288,
      75: 300,
      76: 304,
      80: 320,
      84: 336,
      88: 352,
      90: 360,
      92: 368,
      96: 384,
      100: 400,
      102: 408,
      104: 416,
      108: 432,
      110: 440,
      112: 448,
      116: 464,
      120: 480,
      124: 496,
      128: 512,
      132: 528,
      136: 544,
      140: 560,
      144: 576,
      148: 592,
      150: 600,
      152: 608,
      160: 640,
      164: 656,
      168: 672,
      172: 688,
      176: 704,
      180: 720,
      192: 768,
      256: 1024,
      320: 1280,
      384: 1536,
      512: 2048,
      640: 2560,
      768: 3072,
      1024: 4096,
    },
    zIndex: {
      30: '30',
      40: '40',
      50: '50',
      60: '60',
      70: '70',
      80: '80',
      85: '85',
      90: '90',
      100: '100',
    },
    lineHeight: {
      3: '0.75rem',
      3.5: '0.875rem',
      4: '1rem',
      4.5: '1.125rem',
      5: '1.25rem',
      5.5: '1.375rem',
      6: '1.5rem',
      6.5: '1.625rem',
      7: '1.75rem',
      8: '2rem',
      9: '2.25rem',
      10: '2.5rem',
      10.5: '2.625rem',
      11: '2.75rem',
      12: '3rem',
      13: '3.25rem',
    },
  },
  plugins: [],
};
